import { createSlice } from "@reduxjs/toolkit";
import {
  fetchNotifications,
  ViewedNotifications,
  readNotification,
} from "../service/notificationService";

const initialNotificationState = {
  notifications: [],
  notificationPopup: {},
  totalCount: 0,
  page: 1,
  isNotViewed: 0,
  isLoading: false,
  error: '',
};

export const notificationSlice = createSlice({
  name: "reminder",
  initialState: initialNotificationState,
  reducers: {
    addNotification(state, action) {
      state.notifications = [action.payload, ...state.notifications];
      state.notificationPopup = action.payload;
      state.totalCount++;
      state.isNotViewed++;
    },

    removeNotificationPopup(state) {
      state.notificationPopup = {};
    },
  },
  extraReducers: (builder) => {
    builder
      // fetch notifications
      .addCase(fetchNotifications.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchNotifications.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload.data.page > 1) {
          state.notifications.push(...action.payload.data.data);
        } else {
          state.notifications = action.payload.data.data;
        }
        state.totalCount = action.payload.data.totalCount;
        state.isNotViewed = action.payload.data.isNotViewed;
        state.page = action.payload.data.page;
      })
      .addCase(fetchNotifications.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      })

      // viewed notifications
      .addCase(ViewedNotifications.pending, (state) => {
        // state.isLoading = true;
      })
      .addCase(ViewedNotifications.fulfilled, (state, action) => {
        state.isLoading = false;
        state.notifications = action.payload.data;
        state.isNotViewed = 0;
      })
      .addCase(ViewedNotifications.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      })

      .addCase(readNotification.pending, (state, action) => {
        // state.isLoading = true;
      })
      .addCase(readNotification.fulfilled, (state, action) => {
        state.notifications[action.payload.index] = action.payload.notification;
        state.isNotViewed--;
        state.isLoading = false;
      })
      .addCase(readNotification.rejected, (state, action) => {
        state.error = action.error.message;
        state.isLoading = false;
      });
  },
});

export const { addNotification, removeNotificationPopup } = notificationSlice.actions;

export default notificationSlice.reducer;
